import React from 'react';
import LegalPage from './LegalPage';
import { privacyPolicy } from '../00-shared/constants';

const PrivacyPage: React.FC = () => <LegalPage document={privacyPolicy} />;

export default PrivacyPage;
